'use es6';

import { create } from './strings';
export const get = (spec, config) => {
  const dimensions = config.dimensions || [];
  if (dimensions.includes('people')) {
    return {};
  }
  return create('search').get(spec, config);
};